import React, { useEffect, useState } from "react";
import "../../../Pages/AdminScreens/LeaveManagement/AllLeaveRequests.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import tableimg from "../../../Assets/Images/tableimage.jpg";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import axios from "axios";
import { Apiurl, GetLoginRole, GetToken } from "../../../Utils/utils";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Loader from "../../../Components/loader/loader";
import dummyimage from "../../../Assets/Images/dummyimg.png";


const AllLeaveRequests = () => {
  const getUserRole = GetLoginRole();
  const [showRejectModal, setShowRejectModal] = useState("");
  const [showApproveModal, setShowApproveModal] = useState("");
  const [leavesApprovalData, setLeavesApprovalData] = useState([]);
  const [leaveApprovalDuplicate, setLeaveApprovalDuplicate] = useState([]);
  const [showSidebar, setShowSidebar] = useState(true);
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const [alldata, setalldata] = useState([]);
  const [rejectLeave, setRejectLeave] = useState("");
  const [rejectReasonLength, setRejectReasonLength] = useState(100);
  const [loading, setLoading] = useState(false);

  const LoginToken = GetToken();
  const LeaveRequestsData = () => {
    setLoading(true);

    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetLeaves`,
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.data);
        setalldata(data);
        setLeaveRequestDuplicate(data);
      })
      .catch(() => {});
  };
  useEffect(() => {
    LeaveRequestsData();
  }, []);

  const handleDataSearch = (e) => {
    const searchTerm = e?.target?.value?.toLowerCase();
    if (searchTerm) {
      const filteredData = leaveRequestDuplicate.filter(
        (item) =>
          item?.Reason?.toLowerCase()?.includes(searchTerm) ||
          item?.LeaveTypes?.Name?.toLowerCase()?.includes(searchTerm) ||
          item?.Status?.toLowerCase()?.includes(searchTerm)
      );
      setalldata(filteredData);
    } else {
      setalldata(leaveRequestDuplicate);
    }
  };
  const GetLeavesApproval = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/GetApprovalLeaves`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setLeavesApprovalData(data);
        setLeaveApprovalDuplicate(data);
        setLoading(false);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    GetLeavesApproval();
  }, []);

  const handleApproveLeave = () => {
    setLoading(true);
    const data = {};
    data.Id = showApproveModal;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/ApproveLeave`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setShowApproveModal();
          GetLeavesApproval();
          setLoading(false);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  const handleRejectLeave = () => {
    setLoading(true);
    if (!rejectLeave || rejectLeave.trim() === "") {
      toast.error("Please enter Reason");
      return;
    }
    const data = {};
    data.Id = showRejectModal;
    data.RejectionReason = rejectLeave;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/RejectLeave`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setShowRejectModal("");
          GetLeavesApproval();
          setLoading(false);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}

      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <div
            className={
              showSidebar
                ? "main-container-of-all-employees-Attendance-management"
                : "main-container-of-all-employees-page-new-Attendance-management"
            }
          >
            <div className="inner-container-of-all-employees-page-management ">
              <div className="header-of-employees-page-management row">
                <div className="all-employee-Attendance-management col">
                  <h4>Leave Requests</h4>
                </div>
                <div className="all-employees-Attendance-management col">
                  <div className="home-icon-Attendance-management">
                    <BiHomeAlt className="home-icon-header-Attendance-management" />
                  </div>
                  <div className="arrow-icon-Attendance-management">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="employee-text-Attendance-management">
                    <p>Leave </p>
                  </div>
                  <div className="arrow-icon-Attendance-management">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="all-employee-text-Attendance-management">
                    <p>Leave Requests</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="body-part-outer-Attendance-management">
              <div className="inner-body-container-of-employee-Attendance-management row-12">
                <div className=" first-side-in-body-Attendance-management col-6">
                  <div className="employee-text-in-Attendance-management">
                    <h2>Leave Requests</h2>
                  </div>
                  <div className="input-for-search-in-employee-Attendance-management">
                    <MdSearch className="search-icon-in-Attendance-management" />
                    <input
                      type="text"
                      placeholder=" Search by leave type"
                      onChange={(e) => handleDataSearch(e)}
                    />
                  </div>
                </div>
              </div>
              <div className="table-in-all-emplyee-Attendance-management">
                <table className="table-main-Attendance-management">
                  <thead className="thead-main-Attendance-management">
                    <tr>
                      <th className="image-class-management">Sr.No</th>
                      <th className="image-class-management">Image</th>
                      <th className="image-class-management">Name</th>
                      <th className="image-class-management">Leave Type</th>
                      <th className="image-class-management">Leave From</th>
                      <th className="image-class-management">Leave To</th>
                      <th className="image-class-management">No Of Days</th>
                      <th className="image-class-management">Status</th>
                      <th className="image-class-management">
                        Approval Reason{" "}
                      </th>
                      <th className="image-class-management">Action</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-main-Attendance-management">
                    {alldata?.length ? (
                      <>
                        {alldata
                          ?.sort((a, b) =>
                            a?.userName?.toLowerCase() >
                            b?.userName?.toLowerCase()
                              ? 1
                              : -1
                          )
                          ?.map((item, index) => (
                            <tr className="" key={index}>
                              <>
                                <td>{index + 1}</td>
                                <td>
                                {item?.imageUrl ? (
                                      item?.imageUrl && (
                                        <img
                                          className="image-of-header"
                                          src={item.imageUrl}
                                          onError={(e)=>e.target.src=dummyimage}
                                          alt="Profile Image"
                                        />
                                      )
                                    ) : (
                                      <img src={dummyimage} className="profile-icon-header"/>
                                    )}
                                {/* {item?.UrlLink ? (
                                      item?.UrlLink && (
                                        <img
                                          className="image-of-header"
                                          src={item.UrlLink}
                                          onError={(e)=>e.target.src=dummyimage}
                                          alt="Profile Image"
                                        />
                                      )
                                    ) : (
                                      <img src={dummyimage} className="profile-icon-header"/>
                                    )}
                                  <img
                                    src={tableimg}
                                    alt=""
                                    className="image-in-table-Attendance-management"
                                  /> */}
                                </td>
                                <td>{item?.User?.UserName}</td>
                                <td>{item?.LeaveTypes?.Name}</td>
                                <td>
                                  {" "}
                                  {moment(item?.StartDate).format(
                                    "DD MMM YYYY"
                                  )}
                                </td>
                                <td>
                                  {moment(item?.EndDate).format("DD MMM YYYY")}
                                </td>
                                <td>{item?.NumberofDays}</td>
                                <td>
                                  {/* {item?.Status} */}
                                  <button
                                    className={
                                      item?.Status === "Cancelled"
                                        ? "EMP-Leaves-table-Rejected-button-by-admin"
                                        : item?.Status ===
                                            "RejectedByTeamLead" ||
                                          item?.Status === "RejectedByHR" ||
                                          item?.Status === "RejectedByAdmin"
                                        ? "EMP-Leaves-table-Rejected-button"
                                        : item?.Status === "ApprovedByHR" ||
                                          item?.Status === "ApprovedByTeamLead"
                                        ? "EMP-YetToBeApprovedByTeamLead-button"
                                        : item?.Status ===
                                            "YetToBeApprovedByTeamLead" ||
                                          item?.Status ===
                                            "YetToBeApprovedByHR" ||
                                          item?.Status ===
                                            "YetToBeApprovedByAdmin"
                                        ? "EMP-YetToBeApprovedByTeamLead-button"
                                        : "EMP-Leaves-table-Approved-button"
                                    }
                                  >
                                    {item?.Status ===
                                    "YetToBeApprovedByTeamLead"
                                      ? "Pending at Team Lead"
                                      : item?.Status === "RejectedByTeamLead"
                                      ? "Rejected by Team Lead"
                                      : item?.Status === "RejectedByHR"
                                      ? "Rejected by HR"
                                      : item?.Status === "ApprovedByTeamLead"
                                      ? "Pending at HR"
                                      : item?.Status === "ApprovedByHR"
                                      ? "Pending at Admin"
                                      : item?.Status === "ApprovedByAdmin"
                                      ? "Approved by Admin"
                                      : item?.Status === "RejectedByAdmin"
                                      ? "Rejected by Admin"
                                      : item?.Status === "YetToBeApprovedByHR"
                                      ? "Pending at HR"
                                      : item?.Status ===
                                        "YetToBeApprovedByAdmin"
                                      ? "Pending At Admin"
                                      : item?.Status}
                                  </button>
                                </td>
                                <td>{item?.Reason}</td>
                                {getUserRole === "HR" ? (
                                  <td>
                                    <div className="button_approve_leave">
                                      {item?.Status === "ApprovedByTeamLead" ? (
                                        <>
                                          <button
                                            className="EMP-Approve-table-Approved-button"
                                            onClick={() =>
                                              setShowApproveModal(item?.Id)
                                            }
                                          >
                                            Approve
                                          </button>
                                          <button
                                            className="EMP-Approve-table-Rejected-button"
                                            onClick={() =>
                                              setShowRejectModal(item?.Id)
                                            }
                                          >
                                            Reject
                                          </button>
                                        </>
                                      ) : (
                                        <div className="empty_leave_approval">
                                          -
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                ) : (
                                  <td>
                                    <div className="button_approve_leave">
                                      {item?.Status ===
                                      "YetToBeApprovedByTeamLead" ? (
                                        <>
                                          <button
                                            className="EMP-Approve-table-Approved-button"
                                            onClick={() =>
                                              setShowApproveModal(item?.Id)
                                            }
                                          >
                                            Approve
                                          </button>
                                          <button
                                            className="EMP-Approve-table-Rejected-button"
                                            onClick={() =>
                                              setShowRejectModal(item?.Id)
                                            }
                                          >
                                            Reject
                                          </button>
                                        </>
                                      ) : (
                                        <div className="empty_leave_approval"></div>
                                      )}
                                    </div>
                                  </td>
                                )}
                              </>
                            </tr>
                          ))}
                      </>
                    ) : (
                      <>
                        <tr className="no-record-found-tr-dashboard">
                          <td colSpan="10">No record found</td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      </div>
      {showApproveModal && (
        <div
          className="modal show edit-leaveModal"
          style={{ display: "block" }}
        >
          <Modal.Dialog>
            <Modal.Header
              className="delete-modal-header"
              closeButton
              onClick={() => setShowApproveModal("")}
            >
              <Modal.Title>Approve Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Footer className="Delete-fotter">
              <button
                className="Delete-modal-close-button"
                onClick={() => setShowApproveModal("")}
              >
                Close
              </button>
              <button
                className="Delete-modal-delete-button"
                onClick={() => handleApproveLeave()}
              >
                Approve
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}

      {showRejectModal && (
        <div
          className="modal show edit-leaveModal"
          style={{ display: "block" }}
        >
          <Modal.Dialog>
            <Modal.Header
              className="delete-modal-header"
              closeButton
              onClick={() => setShowRejectModal("")}
            >
              <Modal.Title>Reject Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="textarea-validate">
                <label htmlFor="">Reason</label>
                <textarea
                  type="text"
                  className="textarea-for-delete-leave-api"
                  maxLength={100}
                  value={rejectLeave}
                  onChange={(e) => setRejectLeave(e?.target?.value)}
                />
                {rejectLeave ? (
                  <div className="character_left_leave_approval">
                    {rejectReasonLength - rejectLeave?.length} characters left
                  </div>
                ) : (
                  <div className="character_left_leave_approval">
                    100 characters left
                  </div>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer className="Delete-fotter">
              <button
                className="Delete-modal-close-button"
                onClick={() => setShowRejectModal("")}
              >
                Close
              </button>
              <button
                className="Delete-modal-delete-button"
                onClick={() => handleRejectLeave()}
              >
                Reject
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}
    </>
  );
};
export default AllLeaveRequests;
